module.exports = __webpack_public_path__ + "img/icon-comment-18.4d2dbb10.svg";